import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable, Subject,throwError  } from 'rxjs';
import { Vehicle } from 'src/app/main/vehicles/vehicles.component';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { catchError, filter } from 'rxjs/operators';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { ToastrService } from 'ngx-toastr';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';
import * as CryptoJS from 'crypto-js';
import { allConstant } from 'src/app/_helpers/const';
declare var Tawk_API: any;
import { JSEncrypt } from 'jsencrypt';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SharedService {
  private publicKey: string = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqFk94rdfXR9NBkNh44v3
Jke5lYmd9Tdb3jsQduMhHFlTi2+qLjBnaiOzYQbDHnN8MKnDSI/HOewBfX0UOAhw
S5rYO/MfpFnehylkCW0fttD7rP/CM1ZD7sQt+Xs8KgDj/7uLMy1Bw1KhEHRdND44
mBf9LIubtbv8NY4LBPyJUrTbcXpNqFDicVMN81Mq1hPrq0udqoBInaEkI+beCVWN
dHKHqeybmlkvs23+zGktp+hN0hlmxug78co5yJB4MT9ErvJAqOy0Pz93hNYoI7Nj
hwPf9za0m5VhF3kytwwNF8xue3gDH0wDXxhlEu+wGakto6Z+TJ6siELI1atiqTuH
gwIDAQAB
-----END PUBLIC KEY-----`;
  private fpPromise: Promise<any> | undefined;
  private httpClient: HttpClient;
  private selectedVehicleSource = new BehaviorSubject<Vehicle>({
    make: '',
    model: '',
    year: '',
    vin: '',
  });
  selectedVehicle$ = this.selectedVehicleSource.asObservable();
  private isShowheaderSubject = new BehaviorSubject<boolean>(false);
  isShowheader$ = this.isShowheaderSubject.asObservable();

  url: any = environment.API_URL;
  constructor(
    private http: HttpClient,
    private router: Router,
    private handler: HttpBackend,
    private toastrService: ToastrService,
    private translate: TranslateService
  ) {
    this.fpPromise = FingerprintJS.load();
    this.httpClient = new HttpClient(handler);
  }

  getBannerList(data: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.get(`${this.url}banner/getbanners?${data}`, { headers });
  }

  getAllJobs(data: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.post(`${this.url}careers/jobs`,data);
  }

  getJobById(data: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.get(`${this.url}careers/job/${data}`, { headers });
  }

  uploadImage(file: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.post(this.url + 'upload/image', file, { headers });
  }

  // applyForJob(data : any){
  //   const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
  //   return this.http.post(`${this.url}careers/apply`, data);
  // }
  
  applyForJob(applicationData: any): Observable<any> {
    return this.http.post(this.url + 'careers/apply', applicationData).pipe(
      catchError(error => {
        this.toastrService.error('Failed to submit application. Please try again.');
        return throwError(() => error);
      })
    );
  }

  deleteImage(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Special-Param': 'delete' }),
      body: data,
    };
    return this.http.delete(this.url + 'vin/delete', httpOptions);
  }

  uploadFile(file: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    const response = this.fileValidationCheck(file);
    if (response.status == false) {
      this.toastrService.warning(response.message);
    } else {
      return this.http.post(this.url + 'upload/file', file, { headers });
    }
  }

  uploadVideo(file: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.post(this.url + 'upload/video', file, { headers });
  }

  uploadPdf(file: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.post(this.url + 'upload/pdf', file, { headers });
  }

  dayEndReport(data: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.post(this.url + 'reciept/dayend-report', data, {
      headers,
    });
  }

  getCommentsierarchy(data: any): Observable<any> {
    return this.http.get(
      this.url + 'comment/get-comment-hierarchy?referenceName=' + data
    );
  }

  getTimeFromServer(data: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.get(this.url + `getdbtime/getCurrentTime?${data}`, {
      headers,
    });
  }

  //temp service
  userVerifyWithSendOtp(data: any): Observable<any> {
    return this.http.post(this.url + 'user/send-otp', data);
  }

  userVerifyOtp(data: any): Observable<any> {
    return this.http.post(this.url + 'user/verify-otp', data);
  }

  deleteUser(data: any): Observable<any> {
    return this.http.delete(this.url + `user/remove/${data}`);
  }

  customerQueryCreation(file: any) {
    return this.http.post(this.url + 'public/create-ticket', file);
  }

  globalFileUpload(file: any) {
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.post(this.url + 'public/global-uploader', file, {
      headers,
    });
  }

  resumeFileValidationCheck(file: File): { status: boolean; message: string } {
    if (!file) {
      return { status: false, message: 'No file selected.' };
    }
    
    if (file.type !== 'application/pdf') {
      return { status: false, message: 'Only PDF files are allowed.' };
    }
    const maxSize = 5 * 1024 * 1024; 
    if (file.size > maxSize) {
      return { status: false, message: 'File size should not exceed 5MB.' };
    }
    
    return { status: true, message: 'File is valid.' };
  }

  uploadResumeFile(formData: FormData): Observable<any> {
    const file = formData.get('files') as File;
    const response = this.fileValidationCheck(file);
    
    if (response.status === false) {
      this.toastrService.warning(response.message);
      return throwError(() => new Error(response.message));
    }
    
    const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
    return this.http.post(this.url + 'public/global-uploader-resume', formData, { headers }).pipe(
      catchError(error => {
        this.toastrService.error('File upload failed. Please try again.');
        return throwError(() => error);
      })
    );
  }


  private hideFooter = new BehaviorSubject<any>({});
  hideFooter$ = this.hideFooter.asObservable();

  hideFooterElement(x: any) {
    this.hideFooter.next(x);
  }

  // src\app\shared\services1\shared.service.ts

  getImage() {
    return 'assets/img/imageres.jpg';
  }

  encryptJson(jsonData: any): string {
    const jsonString = JSON.stringify(jsonData); // Convert JSON to string
    const encrypted = CryptoJS.AES.encrypt(
      jsonString,
      CryptoJS.enc.Utf8.parse(allConstant.secretKey),
      {
        iv: allConstant.iv, // Use the same IV
        mode: CryptoJS.mode.CBC, // Use CBC mode
        padding: CryptoJS.pad.Pkcs7, // Use PKCS7 padding
      }
    );

    return encrypted.toString(); // Return encrypted data as Base64 string
  }

  newEncryptJson(data: any) {
    return data;
    if (!this.publicKey) {
      throw new Error('Public key not loaded.');
    }

    try {
      const jsonData = JSON.stringify(data);

      const aesKey = CryptoJS.lib.WordArray.random(16);
      const aesIv = CryptoJS.lib.WordArray.random(16);

      const encryptedPayload = CryptoJS.AES.encrypt(jsonData, aesKey, {
        iv: aesIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();

      const rsa = new JSEncrypt();
      rsa.setPublicKey(this.publicKey);

      const encryptedKey = rsa.encrypt(aesKey.toString(CryptoJS.enc.Base64)); // AES key is Base64-encoded
      const encryptedIv = rsa.encrypt(aesIv.toString(CryptoJS.enc.Base64)); // AES IV is Base64-encoded

      if (!encryptedKey || !encryptedIv) {
        throw new Error('RSA encryption failed.');
      }

      return {
        encryptedKey, // RSA-encrypted AES key (Base64-encoded)
        encryptedIv, // RSA-encrypted AES IV (Base64-encoded)
        encryptedData: encryptedPayload, // AES-encrypted data (Base64-encoded)
      };
    } catch (error) {
      throw new Error('Encryption process encountered an error.');
    }
  }

  getTime() {
    return this.httpClient
      .get('http://worldclockapi.com/api/json/est/now')
      .pipe(
        catchError((error) => {
          throw error; // Rethrow or handle as needed
        })
      );
  }

  objectToQueryString(obj: any) {
    const queryParams = [];

    for (const key in obj) {
      if (
        obj.hasOwnProperty(key) &&
        obj[key] !== undefined &&
        obj[key] !== null
      ) {
        queryParams.push(
          encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])
        );
      }
    }

    return queryParams.join('&');
  }

  private isLoading = new BehaviorSubject<boolean>(false);

  get isLoading$() {
    return this.isLoading.asObservable();
  }

  show() {
    this.isLoading.next(true);
  }

  hide() {
    this.isLoading.next(false);
  }

  getEventService(url: string) {
    var thid = this;
    fetchEventSource(this.url + url, {
      method: 'GET',
      headers: {
        Authorization: 'Basic ' + window.btoa('3xaUser!@3#:9raPass@3!)#@done'), // Include headers if needed
        'Other-Header': 'value',
      },
      onmessage(event) {
        if (event.data != '') {
          const formatedData = JSON.parse(event.data);
          if (
            formatedData?.eventName == 'USER_LOGOUT' &&
            formatedData?.success == true
          ) {
            if (
              formatedData?.eventName == 'USER_LOGOUT' &&
              formatedData?.success == true
            ) {
              let currentUsers = formatedData.userIds.filter(
                this.currentUser._id
              );
              if (this.currentUser._id == currentUsers) {
                localStorage.removeItem('currentUser');
                thid.navigateTohome();
              }
            }
          }
        }
      },
    });
  }

  geteventurl(url: string) {
    return this.url + url;
  }

  navigateTohome() {
    this.router.navigate(['']);
  }

  private readonly idSubject = new BehaviorSubject<string | null>(null);
  readonly id$ = this.idSubject.asObservable();

  setId(id: string | null): void {
    this.idSubject.next(id);
  }

  cloudFrontUrl(size: any, url: any) {
    if (url?.includes('/assets/')) {
      const dynamicPath = url?.split('/assets/').pop();
      const cdnUrl = `${environment.CF_URL}${size}/assets/${dynamicPath}`;
      return cdnUrl;
    } else {
      return url;
    }
  }

  cloudFrontPdfUrl(url: string) {
    if (environment.production) {
      const pdfPath = url.replace(/^https?:\/\/[^/]+\/?/, '');
      return `${environment.CF_PDF_URL || environment.CF_URL}${pdfPath}`;
    } else {
      return url; 
    }
  }


  async getFingerprint(): Promise<string> {
    if (!this.fpPromise) {
      throw new Error('FingerprintJS is not initialized');
    }

    const fp = await this.fpPromise;
    const result = await fp.get();
    return result.visitorId; // or use result.hash, depending on what you need
  }

  speak(text: string): void {
    speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    speechSynthesis.speak(utterance);
  }

  stop(): void {
    speechSynthesis.cancel(); // Stops current speech
  }

  // You can customize the voice and language here if needed
  setVoice(voiceName: string): void {
    const voices = speechSynthesis.getVoices();
    const voice = voices.find((v) => v.name === voiceName);
    if (voice) {
      const utterance = new SpeechSynthesisUtterance('Test');
      utterance.voice = voice;
      speechSynthesis.speak(utterance);
    }
  }

  setSelectedVehicle(vehicle: any) {
    this.selectedVehicleSource.next(vehicle);
  }

  setIsShowHeader(isShow: boolean) {
    this.isShowheaderSubject.next(isShow);
  }

  private allowedExtensions = ['png', 'jpg', 'jpeg', 'pdf'];
  fileValidationCheck(file: any) {
    // const file: File | null = files.get('myFile') as File;
    if (file) {
      // Extract the file extension
      const fileName: string = file?.name;
      const fileExtension: string =
        fileName?.split('.').pop()?.toLowerCase() || '';

      // Check if the extension is allowed
      if (!this.allowedExtensions.includes(fileExtension)) {
        return {
          status: false,
          message: this.translate.instant('tooltips.message36'),
        };
      } else {
        return { status: true, message: 'success.' };
      }
    } else {
      return { status: false, message: 'No file provided.' };
    }
  }

  //#region key Remove
  /**
   * @param input 
   * @param keysToRemove 
   * @returns A new object or array without the specified keys.
   */
  removeKeysDeep(obj: any, keysToRemove: string[]): any {
  const clone = JSON.parse(JSON.stringify(obj)); // deep copy

  for (const keyPath of keysToRemove) {
    const parts = keyPath.split('.');
    let target = clone;

    for (let i = 0; i < parts.length - 1; i++) {
      if (target[parts[i]] == null) {
        target = null;
        break;
      }
      target = target[parts[i]];
    }

    if (target && parts[parts.length - 1] in target) {
      delete target[parts[parts.length - 1]];
    }
  }

  return clone;
}



  getDevicePlatform(): string {
    const userAgent = navigator.userAgent;

    // Check for mobile device
    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return 'iOS';
    }

    // Check for Windows
    if (/Windows NT/i.test(userAgent)) {
      return 'Windows';
    }

    // Check for macOS
    if (/Macintosh|Mac OS X/i.test(userAgent)) {
      return 'macOS';
    }

    // Check for Linux
    if (/Linux/i.test(userAgent)) {
      return 'Linux';
    }

    // Default if no specific platform detected
    return 'Unknown';
  }

  subscriptionService(data: any) {
  return this.http.post(this.url + 'public/subscribe', data);
}
}
